export default function SystemIcon() {
  return (
    <svg width="16" height="16" strokeLinejoin="round">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M0 2a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v8.5a1 1 0 0 1-1 1H8.75v3h1.75V16h-5v-1.5h1.75v-3H1a1 1 0 0 1-1-1V2Zm1.5.5V10h13V2.5h-13Z"
        clipRule="evenodd"
      />
    </svg>
  )
}
